import { formatNumber } from './format-number';

// Accepts a fraction (e.g. 0.25 -> "25.00 %"), matching the behavior of the
// previous Intl.NumberFormat({ style: 'percent' }) formatter it replaces.
export const formatPercentage = (value: number | null | undefined): string => {
    if (value === null || value === undefined || Number.isNaN(value)) return '';
    const number = formatNumber(value * 100, {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    });
    return `${number} %`;
};
